export default __webpack_public_path__ + "static/media/mecha-walking.18827564.png";